module.exports = __webpack_public_path__ + "0fc32523e61537e7b2e41b1e4a95da09.pdf";